import {Component, Inject, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {OrderService} from '../../order.service';
import { ActivatedRoute, Router } from '@angular/router';
import {CardDetails, OrdersWithPayment, PaymentMethods, cardBrandIcon} from 'src/app/models/order';
import { WalletData } from 'src/app/models/wallet';
import { GuestPaymentDetailService } from 'src/app/_services/gpd.service';
import { Store } from 'src/app/models/store';
import { PaymentOption } from 'src/app/_services/payment-option.service';
import { get } from 'scriptjs';
import {DOCUMENT} from '@angular/common';
import {WalletAddCardconnectComponent} from './wallet-add-cardconnect/wallet-add-cardconnect.component';
import {PaymentComponent} from '../../payment/payment.component';
import {WalletAddStripeComponent} from './wallet-add-stripe/wallet-add-stripe.component';
import {OrderHelpers} from '../utils/helpers';
import {ComponentCanDeactivate} from '../../_helpers/pending-changes-gaurd';
import { UserLoginComponent } from '../user-login/user-login.component';
import {ThreedsCheckComponent} from '../threeds-check/threeds-check.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import {PaymentGatewayService} from '../../_services/payment-gateway.service';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { Constants } from 'src/app/constants';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var iTransact
declare var CollectJS

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WalletComponent implements OnInit, OnDestroy, ComponentCanDeactivate {
  /** Brand icon for a saved card; falls back to a generic card when the gateway's `card_type` has no artwork. */
  readonly cardBrandIcon = cardBrandIcon;


  private destroy$ = new Subject<void>();
  storeId: string;
  phoneNumber: string;
  paymentGateway: string;
  hash: string;
  orderID = null;
  order: OrdersWithPayment;
  wallet: WalletData;

  allCards: CardDetails[] = [];
  store: Store;

  loadAPI: Promise<any>;
  payrocHandler: any;

  selectMode = false;
  /** ENG-5609: unverified guest. Saved cards and store credit stay hidden; the card entered
   *  here is for this order only. */
  guestCheckout = false;
  forOffer  = false;

  mUseStoreCredit = false;
  mUseCash = false;
  mUseCard = false;
  isLoading = false;

  showBillingAddressForm = false;
  isVerifyingCard = false;
  billingStreet = '';
  billingCity = '';
  billingZip = '';
  addressError = '';
  private pendingVerifyCard: CardDetails = null;

  constructor(
    public dialogRef: MatDialogRef<WalletComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService,
    private route: ActivatedRoute,
    private router: Router,
    private gpd: GuestPaymentDetailService,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private paymentGatewayService: PaymentGatewayService,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService) {
      this.selectMode = this.data.selectMode;
      // ENG-5609: guest mode. The card is for this order only and nothing belonging to the
      // unverified number may be shown.
      this.guestCheckout = !!this.data.guestCheckout;
      this.forOffer = this.data.forOffer;

      this.order = this.data.order;
      if(this.selectMode){
        this.storeId = this.data.order.store.id;
      }else{
        this.storeId = this.route.snapshot.paramMap.get('storeId');
      }

      this.hash = this.route.snapshot.paramMap.get('hash');
      this.phoneNumber = localStorage.getItem('phoneNumber');
      if (this.hash != 'null' && this.hash != 'undefined') {
        this.hashToPhoneNumber();
      } else {
        const savedHash = localStorage.getItem('userHash');
        if (savedHash && this.phoneNumber) {
          this.hash = savedHash;
          this.router.navigate(['store', this.storeId, savedHash, 'wallet'], { replaceUrl: true });
        } else {
          this.userLogin();
        }
      }
      if(this.storeId){
        this.orderService.getStoreInfo(this.storeId).pipe(takeUntil(this.destroy$)).subscribe(store => {
          this.store = Object.assign(new Store(), store);
          this.paymentGateway = this.store.payment_gateway;
          this.cdr.markForCheck();
          this.loadAPI = new Promise((resolve, reject) => {
            let node = this.loadScript(this.store.nmi_public_key);
            if (node) {
                node.onload = () => {resolve(true);};
                // Without onerror the promise never settled and Add Card stayed silently dead.
                node.onerror = () => {reject(new Error('Collect.js failed to load'));};
                // Ad blockers can swallow the request without firing onerror — fail loudly.
                setTimeout(() => reject(new Error('Collect.js load timed out')), 15000);
            } else {
                resolve(true);
            }
          });
          this.store = Object.assign(new Store(), store);
          this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);

          // After redirect back from Worldnet, trigger AVS verification if enabled
          const pendingWorldnetCard = localStorage.getItem('pending_worldnet_card_added');
          if (pendingWorldnetCard && !this.selectMode) {
            localStorage.removeItem('pending_worldnet_card_added');
            if (this.isAvsRequired()) {
              this.triggerPendingCardVerification();
            }
          }

          if(this.store && this.store.payment_gateway === 'PAYROC'){

            let options = {
              apiUsername: this.store.payroc_username,
              name: 'Please add card details below:',
              description: '',
              onToken: this.submit.bind(this),
              requireEmail: false
            }

            get("https://js.itransact.com/itransact.js", () => {
              var handler = iTransact.Checkout.init(options)
              this.payrocHandler = handler;
              this.document.getElementById('payroc-button').addEventListener('click', function (event) {
                handler.render({
                  panelButtonText: "Add Card",
                  theme: "#467adb",
                  email: 'support@labrador.ai'
                })
                event.preventDefault()
              })
            });
          }
        });
      }


    }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.showBillingAddressForm || this.isVerifyingCard) {
      $event.returnValue = true;
    }
  }

  canDeactivate(): boolean {
    return !(this.showBillingAddressForm || this.isVerifyingCard);
  }

  ngOnInit(): void {
    if(this.loadAPI){
      this.loadAPI.then((flag) => {
        try {
        CollectJS.configure({
          'paymentType': 'cc',
          'primaryColor': '#1e88e5',
          'buttonText': 'Add Card',
          'instructionText': 'Enter Card Info Below',
          'theme': 'material',
          'callback': function (response) {
            try {
            response.store_id = this.storeId;
            response.phone_number = this.phoneNumber;
            response.payment_gateway = this.paymentGateway;
            this.orderService.addNewCardGateway(response).subscribe(response => {
              this._snackBar.open('Payment method added', '', { duration: 3000, verticalPosition: 'top'});
              CollectJS.closePaymentRequest();
              this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
            }, (error) => {
              try { CollectJS.closePaymentRequest(); } catch (e) { }
              this.analyticsService.captureException(error, { step: 'add_card_gateway_wallet' });
              this._snackBar.open('We could not save your card. Please try again.', 'OK', { verticalPosition: 'top' });
            })
            } catch (error) {
              this.analyticsService.captureException(error, { step: 'collectjs_callback_wallet' });
              this._snackBar.open('Something went wrong adding your card. Please try again.', 'OK', { verticalPosition: 'top' });
            }
          }.bind(this)
        });
        } catch (error) {
          this.analyticsService.captureException(error, { step: 'collectjs_configure_wallet' });
        }
      }).catch((error) => {
        this.analyticsService.captureException(error, { step: 'collectjs_load_wallet' });
        this._snackBar.open('Card entry could not load. Please refresh and try again.', 'OK', { verticalPosition: 'top' });
      });
    }
  }

  hashToPhoneNumber() {
    if (this.hash) {
      this.orderService.hashToPhoneNumber(this.hash).subscribe((data:any) => {
        localStorage.setItem("phoneNumber", data.phone_number);
        localStorage.setItem('userHash', this.hash);
        this.phoneNumber = data.phone_number;
        if (this.store) {
          this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
        }
      });
    }
  }

  userLogin() {
    let dialogRef = this.dialog.open(UserLoginComponent, {
      disableClose: true,
      width: '400px',
      data: {
        store: this.storeId
      }
    });
    dialogRef.afterClosed().subscribe(phoneHash => {
      if (phoneHash) {
        this.hash = phoneHash;
        this.phoneNumber = localStorage.getItem("phoneNumber") ?? '';
        localStorage.setItem('userHash', phoneHash);
        if (this.store) {
          this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
        }
        this.router.navigate(['store', this.storeId, phoneHash, 'wallet'], { replaceUrl: true });
        this.cdr.markForCheck();
      }
    });
  }

  close(){
    this.dialogRef.close();
  }

  goToHome(){
    if(this.selectMode){
      this.close();
    }else{
      window.history.back();
    }
  }

  refresh(){
    this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
  }

  getCards(storeId, phoneNumber, paymentGateway){
    // ENG-5610: both of these return everything saved against the phone number. A guest, or
    // anyone who has not proved the number, gets neither — the template already hides the saved
    // card and gift card sections for them, so this stops us asking for what we cannot show.
    // selectMode is checkout, where the order carries the verification state. The standalone
    // wallet page has no order; it is reached through the account menu, which store-header
    // already gates on the device token.
    // The gift card page opens this against an offer order, which keeps the flag on offer_order
    // rather than bot_order. Reading only bot_order hid every saved card from gift card buyers.
    // `order` is typed as a food order; the offer order shares the shape only loosely.
    const verifiedOnOrder = this.forOffer
      ? !!(this.order as any)?.offer_order?.phone_number_verified
      : !!this.order?.bot_order?.phone_number_verified;
    const numberProved = !this.selectMode || verifiedOnOrder;
    if (this.guestCheckout || !numberProved) {
      this.wallet = { cards: [], store_credit: 0 };
      this.allCards = [];
      this.cdr.markForCheck();
      return;
    }

    this.orderService.getCards(storeId, phoneNumber, paymentGateway).subscribe(data => {
      this.wallet = data;
      this.cdr.markForCheck();
    });

    this.gpd.getAllCards(storeId, phoneNumber, paymentGateway).subscribe(data => {
      this.allCards = data.map(d => Object.assign(new CardDetails(), d));
      this.cdr.markForCheck();
    })
  }

  loadScript(nmiPublicKey) {
    let node = undefined;
    let isFound = false;
    const scripts = document.getElementsByTagName('script')
    for (let i = 0; i < scripts.length; ++i) {
        // Check if script is already there in html
        if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
          isFound = true;
        }
    }

    if (!isFound) {
        const dynamicScript = 'https://secure.networkmerchants.com/token/Collect.js';
        node = document.createElement('script');
        node.src = dynamicScript;
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        node.setAttribute('data-tokenization-key', nmiPublicKey);
        document.getElementsByTagName('head')[0].appendChild(node);
        return node;
    }
    return node;
  }

  openGateway(event){
    if(this.store.payment_gateway === 'NMIPR' || this.store.payment_gateway === 'NMI'){
      this.openCollectJsLightBox(event)
    }
  }

  openCollectJsLightBox(event){
    if (typeof CollectJS === 'undefined') {
      this._snackBar.open('Card entry is still loading. Please try again in a moment.', 'OK', { verticalPosition: 'top' });
      this.analyticsService.captureException(new Error('CollectJS undefined at startPaymentRequest'), { step: 'collectjs_missing_wallet' });
      return;
    }
    try {
    CollectJS.configure({
      'paymentType': 'cc',
      'primaryColor': '#1e88e5',
      'buttonText': 'Add Card',
      'instructionText': 'Enter Card Info Below',
      'theme': 'material',
      'callback': function (response) {
        try {
        response.store_id = this.store.id;
        response.phone_number = this.phoneNumber;
        response.payment_gateway = this.paymentGateway;

        this.orderService.addNewCardGateway(response).subscribe(card => {
          this._snackBar.open('Payment method added', '', { duration: 3000, verticalPosition: 'top'});
          CollectJS.closePaymentRequest();
          if(this.store.isEnabled('3DS')){
            this.threeDSecureCheck(card);
          }else{
            this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
          }
        }, (error) => {
          try { CollectJS.closePaymentRequest(); } catch (e) { }
          this.analyticsService.captureException(error, { step: 'add_card_gateway_wallet' });
          this._snackBar.open('We could not save your card. Please try again.', 'OK', { verticalPosition: 'top' });
        })
        } catch (error) {
          this.analyticsService.captureException(error, { step: 'collectjs_callback_wallet' });
          this._snackBar.open('Something went wrong adding your card. Please try again.', 'OK', { verticalPosition: 'top' });
        }
      }.bind(this)
    });
    CollectJS.startPaymentRequest(event)
    } catch (error) {
      this.analyticsService.captureException(error, { step: 'collectjs_start_payment_request_wallet' });
      this._snackBar.open('Card entry could not open. Please refresh and try again.', 'OK', { verticalPosition: 'top' });
    }
  }

  threeDSecureCheck(card: CardDetails){
    let dialogRef = this.dialog.open(ThreedsCheckComponent, {
      data: {
        nameOnCard: card.name_on_card,
        customerVaultId: card.nmi_customer_vault_id,
        total: 2,
        gatewayId: this.store.nmi_public_key
      },
      disableClose: true,
      panelClass: ['full-screen-modal']
    });

    dialogRef.afterClosed().subscribe(data => {
      console.log(data);
      if(data){
        this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
      }else{
        this.orderService.deleteCard(card).subscribe(data => {
          this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
        })
      }
    });
  }

  submit(data){
    let payload = {
      'store_id': this.store.id,
      'phone_number': this.phoneNumber,
      'token': data.token,
      'payment_gateway': this.store.payment_gateway,
      // ENG-5609: a guest has not proved the number is theirs, so the card is never kept.
      'is_one_time': this.guestCheckout
    }

    this.orderService.addNewCardGateway(payload).subscribe(response => {
      this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
    },
    error => {})
  }

  openCardConnect(){
    let dialogRef = this.dialog.open(WalletAddCardconnectComponent, {
      panelClass: 'full-screen-modal',
      height: 'auto',
      width: 'auto',
      data: {paymentGateway: this.paymentGateway, storeId: this.storeId,
             phoneNumber: this.phoneNumber, guestCheckout: this.guestCheckout}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
      }
    });
  }

  isAvsRequired(): boolean {
    return this.store?.payment_gateway === 'WORLDNET' && this.store?.isEnabled('worldnet_penny_verification');
  }

  isCardUsable(card: CardDetails): boolean {
    if (card.is_deleted || card.hasExpired()) return false;
    if (this.isAvsRequired() && card.is_avs_verified !== true) return false;
    return true;
  }

  gotoOrSelect(card: CardDetails){
    if(this.selectMode){
      if(this.isCardUsable(card)){
        const paymentOption = new PaymentOption(false, true, this.mUseStoreCredit, card,
          this.wallet.store_credit)
        this.dialogRef.close(paymentOption);
      }
    }else{
      this.router.navigate(['/', 'store' , this.storeId, this.hash, 'wallet', card.id])
    }
  }

  verifyCardAvs(card: CardDetails){
    if (this.selectMode) {
      this.dialogRef.close({ action: 'verify_card', card: card });
      return;
    }

    const orderHash = localStorage.getItem('order_hash');
    if (!orderHash) {
      this._snackBar.open('Please start an order to verify your card', '', { duration: 3000, verticalPosition: 'top' });
      return;
    }

    // Set preferred payment to this card first
    this.pendingVerifyCard = card;
    this.isVerifyingCard = true;
    this.cdr.markForCheck();

    const payload = { is_cash: false, is_card: true, is_store_credit: false, guest_payment_id: card.id };
    this.orderService.updatePreferredPayment(orderHash, payload).subscribe(
      () => {
        // Show billing address form directly instead of calling verify API first
        this.isVerifyingCard = false;
        this.billingStreet = '';
        this.billingCity = '';
        this.billingZip = '';
        this.addressError = '';
        this.showBillingAddressForm = true;
        this.cdr.markForCheck();
      },
      () => {
        // Even if updatePreferredPayment fails, still show the form
        this.isVerifyingCard = false;
        this.billingStreet = '';
        this.billingCity = '';
        this.billingZip = '';
        this.addressError = '';
        this.showBillingAddressForm = true;
        this.cdr.markForCheck();
      }
    );
  }

  private triggerPendingCardVerification() {
    const orderHash = localStorage.getItem('order_hash');
    if (!orderHash) return;

    // After Worldnet redirect, show billing address form directly
    this.billingStreet = '';
    this.billingCity = '';
    this.billingZip = '';
    this.addressError = '';
    this.showBillingAddressForm = true;
    this.cdr.markForCheck();
  }

  private _doVerifyCard(orderHash: string) {
    this.paymentGatewayService.verifyCard(orderHash).subscribe(
      (result: any) => {
        this.isVerifyingCard = false;
        if (result.verified) {
          this._snackBar.open('Card verified successfully', '', { duration: 3000, verticalPosition: 'top' });
          this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
        } else {
          this._snackBar.open(result.message || 'Card verification failed', '', { duration: 5000, verticalPosition: 'top' });
          // Show billing form again so user can retry with correct address
          this.showBillingAddressForm = true;
          this.addressError = result.message || 'Verification failed. Please check your billing address.';
        }
        this.cdr.markForCheck();
      },
      () => {
        this.isVerifyingCard = false;
        this._snackBar.open('Card verification failed. Please try again.', '', { duration: 3000, verticalPosition: 'top' });
        this.showBillingAddressForm = true;
        this.addressError = 'Verification failed. Please try again.';
        this.cdr.markForCheck();
      }
    );
  }

  submitBillingAddress() {
    if (!this.billingStreet.trim() || !this.billingCity.trim() || !this.billingZip.trim()) {
      this.addressError = 'All billing address fields are required.';
      this.cdr.markForCheck();
      return;
    }
    const orderHash = localStorage.getItem('order_hash');
    if (!orderHash) {
      this.addressError = 'No active order found. Please start an order first.';
      this.cdr.markForCheck();
      return;
    }

    this.showBillingAddressForm = false;
    this.isVerifyingCard = true;
    this.addressError = '';
    this.cdr.markForCheck();

    this.paymentGatewayService.updateBillingAddress(
      orderHash, this.billingStreet.trim(), this.billingCity.trim(), this.billingZip.trim()
    ).subscribe(
      () => this._doVerifyCard(orderHash),
      () => {
        this.isVerifyingCard = false;
        this.showBillingAddressForm = true;
        this.addressError = 'Failed to save billing address. Please try again.';
        this.cdr.markForCheck();
      }
    );
  }

  skipBillingAddress() {
    this.showBillingAddressForm = false;
    this.pendingVerifyCard = null;
    this.addressError = '';
    localStorage.removeItem('pending_worldnet_card_added');
    localStorage.removeItem('worldnet_card_return_url');
    this.cdr.markForCheck();
  }

  selectMobilePaymentService(){
    if(this.selectMode){
        const paymentOption = new PaymentOption(false, false, this.mUseStoreCredit, null,
          this.wallet.store_credit, true)
        this.dialogRef.close(paymentOption);
    }else{
      this.router.navigate(['/', 'store' , this.storeId, this.hash, 'wallet'])
    }
  }

  openStripe(){
    let dialogRef = this.dialog.open(WalletAddStripeComponent, {
      panelClass: 'full-screen-modal',
      height: 'auto',
      width: 'auto',
      data: {paymentGateway: this.paymentGateway, storeId: this.store.id, phoneNumber: this.phoneNumber}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getCards(this.store.id, this.phoneNumber, this.store.payment_gateway);
      }
    });
  }

  addWorldnetCard(){
    localStorage.setItem('pending_worldnet_card_added', 'true');
    if (!this.selectMode) {
      localStorage.setItem('worldnet_card_return_url', `/store/${this.storeId}/${this.hash}/wallet`);
    } else {
      // Clear any stale return URL from a previous wallet attempt
      localStorage.removeItem('worldnet_card_return_url');
    }
    this.redirectToWorldnet();
  }

  redirectToWorldnet(){
    const orderHash = localStorage.getItem('order_hash')
    const phoneNumber = localStorage.getItem(Constants.PHONE_NUMBER_KEY)
    if(orderHash){
      // Ensure the order has the phone number before initiating Worldnet payment.
      // A phoneless temp order will cause the Worldnet HPP callback to crash (500).
      // Carry the typed order name so the backend persists it atomically before
      // the Worldnet redirect, which otherwise drops it. Falls back to the
      // order-specific then global cached name; omitted if none was entered.
      const orderName = localStorage.getItem(orderHash + 'order-name') || localStorage.getItem('orderName') || undefined;
      const submitHPP = () => {
        this.paymentGatewayService.getHPPUrl(+this.store.id, orderHash, orderName).subscribe((data: any) => {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = "https://payments.worldnettps.com/merchant/securecardpage";

          for (const key in data) {
            if (data.hasOwnProperty(key)) {
              const hiddenField = document.createElement('input');
              hiddenField.type = 'hidden';
              hiddenField.name = key;
              hiddenField.value = data[key];
              form.appendChild(hiddenField);
            }
          }

          document.body.appendChild(form);
          form.submit();
        });
      };

      if (phoneNumber) {
        // Update the order's phone number before payment to prevent phoneless order issues
        this.orderService.updatePhoneNumber(orderHash, phoneNumber).subscribe(
          () => submitHPP(),
          () => submitHPP() // proceed even if update fails — backend guard will catch it
        );
      } else {
        submitHPP();
      }
    }else{
      alert('invalid order id')
    }
  }

  useStoreCredit(withCash = false){
    let storeCredit = this.wallet ? this.wallet.store_credit : 0;
    const paymentOption = new PaymentOption(withCash, false, true, null,
      storeCredit)
    this.dialogRef.close(paymentOption);
  }

  /**
   * ENG-5609: a guest pays on Worldnet's hosted payment page, not securecardpage. securecardpage
   * exists to tokenise a card for reuse, which is exactly what a number nobody has verified must
   * not get. This is the same route the wallet option already takes, and onSubmit() performs the
   * redirect once the order is ready.
   */
  payAsGuestByCard(){
    this.dialogRef.close(new PaymentOption(false, false, false, null, 0, true));
  }

  useCash(){
    let storeCredit = this.wallet ? this.wallet.store_credit : 0;
    const paymentOption = new PaymentOption(true, false, false, null,
      storeCredit)
    this.dialogRef.close(paymentOption);
  }

  goToMyOffers(){
    this.router.navigate(['/', 'store', this.storeId, this.hash, 'my-offers']);
  }

  goToSendGift(){
    this.router.navigate(['/', 'store' , this.storeId, this.hash, 'send-gift'])
  }

  isMultipleMethods(){
    if(this.wallet && this.order){
      return this.wallet.store_credit > 0 && this.wallet.store_credit < this.order?.payment.total && this.selectMode;
    }else{
      return false;
    }

  }

  getStoreCreditCardBalance(){
    return this.order.payment.total - this.wallet.store_credit;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getStoreCreditCashBalance(){
    return this.order.payment.cash_due_total - this.wallet.store_credit;
  }

  mUseCashMethod(){
    this.mUseStoreCredit = true;
    this.mUseCash = true;
    this.mUseCard = false;
  }
  mUseCardMethod(){
    this.mUseStoreCredit = true;
    this.mUseCash = false;
    this.mUseCard = true;
  }

  refreshOrder(){
    this.isLoading = true;
    this.orderService.getOrder(this.order.bot_order.order_hash, "0").subscribe(data => {
      this.order = OrderHelpers.parseOrder(data)
      this.isLoading = false;
    });
  }

}